<template>
    <v-container fluid 
        :class="{fixed: $route.name === 'login' || $vuetify.breakpoint.smAndDown}">
        <v-layout 
        row wrap justify-center>
            <v-flex class="text-xs-center" xs12 sm4>
                
            </v-flex>
            <v-flex class="text-xs-center" xs12 sm4>
                <a href="https://wdt.vde-service.de/wdt/datenschutzerklaerung.pdf" target="_blank">Datenschutzerklärung</a>
            </v-flex>
            <v-flex class="text-xs-center" xs12 sm4>
                <a href="https://wdt.vde-service.de/wdt/impressum.html" target="_blank">Impressum</a>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    data: () => ({

    })
}
</script>

<style scoped>

.container {
    padding-top: 0;
    padding-bottom: 0;

    border-top: 1px solid rgba(0,0,0, 0.2);
    background-color: rgb(241, 243, 248);

    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-flex: 0 !important;
    -ms-flex: 0 1 auto !important;
    flex: 0 1 auto !important;
    min-height: 36px;
    -webkit-transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.fixed {
    z-index: 10; 
    position: fixed; 
    bottom: 0;
}

a {
    text-decoration: none;
    color: rgb(67, 114, 196);
} 
a:hover{
    text-decoration: underline;
}
</style>

